<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">割引対象会員リスト</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <div class="coupon-info member-info">
              <CRow>
                <CCol lg="6" class="p-0">
                  <CInput
                    label="クーポンID"
                    horizontal
                    plaintext
                    v-model="couponId"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6" class="p-0">
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">利用開始日</label>
                    <div class="col-sm-9">
                      <span>{{
                        allCouponList.validateSince | formatDate
                      }}</span>
                    </div>
                  </div>
                </CCol>
                <CCol lg="6" class="p-0">
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">利用開始日</label>
                    <div class="col-sm-9">
                      <span>{{
                        allCouponList.validateUntil | formatDate
                      }}</span>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </div>
            <div class="coupon-feature-image py-3" v-if="allCouponList.picture">
              <div><h4 class="sub-title mb-3">クーポンバナー</h4></div>
              <CImg fluid :src="allCouponList.picture" :align="center" class="rounded mx-auto my-3 d-block" />
            </div>
            <!-- coupon-feature-image end -->
            <div class="user-info-table">
              <dl class="row">
                <dt class="col-sm-12">
                  <h4 class="sub-title">会員一覧</h4>
                  <!-- <p>
                    全登録数: <b>{{ userCount }}</b> | 検索ヒット件数:
                    <b>{{ searchCount }}</b>
                  </p> -->

                  <!-- <pre><code>{{ tableData }}</code></pre> -->
                </dt>
              </dl>
              <CDataTable
                class="mb-0 table-outline"
                hover
                size="sm"
                :items="tableData"
                :fields="userTableFields"
                head-color="light"
                column-filter
                sorter
                itemps-per-page-select
                :items-per-page="100"
                pagination
                v-if="loading"
              >
                <td slot="optionName" class="text-left" slot-scope="{ item }">
                  <strong>{{ item.optionName }}</strong>
                </td>
                <td slot="description" class="text-left" slot-scope="{ item }">
                  <strong
                    class="pointer text-info"
                    v-c-tooltip.hover="{ content: item.description }"
                    color="secondary"
                    >{{ item.description | wordLimit(15, "...") }}</strong
                  >
                </td>
                <td slot="familyName" slot-scope="{ item }">
                  <strong>{{ item.user.familyName }}</strong>
                </td>
                <td slot="givenName" slot-scope="{ item }">
                  <strong>{{ item.user.givenName }}</strong>
                </td>
                <td slot="cardId" class="text-left" slot-scope="{ item }">
                  <strong>{{ item.user.cardId }}</strong>
                </td>
                <td slot="mobile" slot-scope="{ item }">
                  <strong>{{ item.user.mobile }}</strong>
                </td>
                <template #profile_edit="{ item }">
                  <td class="py-2 text-center">
                    <CButton
                      color="danger"
                      square
                      block
                      size="sm"
                      @click="openChangeStatusDialog(item.id)"
                      >解除</CButton
                    >
                  </td>
                </template>
              </CDataTable>
              <CAlert v-if="!loading" color="danger" class="mt-3 text-center"
                >現在、利用可能なクーポンはありません。</CAlert
              >
              <CButton @click="goBack()" class="my-5 btn btn-dark px-5">
                <i class="icon cil-arrow-left"></i> 戻る
              </CButton>
              <!-- <pre>
              <code>{{ couponList }}</code>
              </pre> -->
            </div>
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- Change coupon status modal start -->
    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :show.sync="couponDeactivateModal"
    >
      <div class="coupon-info">割引を解除してよろしいですか？</div>
      <template #header> 割引解除確認 </template>
      <template #footer>
        <CButton @click="couponDeactivateModal = false" color="secondary">
          キャンセル</CButton
        >
        <CButton @click="putCouponStatus()" color="danger"> 解除実行</CButton>
      </template>
    </CModal>
    <!-- Change coupon status modal end -->
    <!-- Change coupon status modal start -->
    <CModal color="success" :closeOnBackdrop="false" :show.sync="completeModal">
      <div class="coupon-info">割引の解除が完了しました。</div>
      <template #header> 割引解除完了</template>
      <template #footer>
        <CButton @click="completeModal = false" color="danger"> 閉じる</CButton>
      </template>
    </CModal>
    <!-- Change coupon status modal end -->
    <!-- Complete Dialog ↑↑↑ -->
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";

export default {
  name: "CouponsAcquiredList",
  components: {},
  data() {
    return {
      linkD: "",
      couponId: "",
      userCount: 0,
      userCouponID: "",
      couponDeactivateModal: false,
      completeModal: false,
      loading: false,
      couponList: [
        {
          id: "",
          shortCode: "",
          activated: "",
          user: {
            id: "",
            name: "",
            familyName: "",
            givenName: "",
            lastName: "",
            firstName: "",
            mobile: "",
            email: "",
            points: {
              id: "",
            },
            cardId: "",
            discounts: [],
          },
          sku: "",
          optionName: "",
          optionDescription: "",
          name: "",
          description: "",
          validateSince: "",
          validateUntil: "",
        },
      ],
      allCouponList: [
        {
          id: "",
          sku: "",
          name: "",
          description: "",
          picture: null,
          options: [
            {
              id: "",
              sku: "",
              name: "",
              reduction: 0,
            },
          ],
          activatedBefore: "",
          validateSince: "",
          validateUntil: "",
          multiple: Boolean,
        },
      ],
      tableData: [],
      userTableFields: [
        { key: "optionName", label: "オプション名", _classes: "text-center bg-light" },
        { key: "description", label: "説明", _classes: "text-center bg-light" },
        { key: "familyName", label: "氏", _classes: "text-center bg-light" },
        { key: "givenName", label: "名", _classes: "text-center bg-light" },
        { key: "cardId", label: "会員ID", _classes: "text-center bg-light" },
        { key: "mobile", label: "	電話番号", _classes: "text-center bg-light" },
        // { key: "電話番号", label: "提出時間", _classes: "text-right" },
        {
          key: "profile_edit",
          label: "解除",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
      ],
       

    };
  },
  created() {
    this.couponId = this.$route.params.couponId;
  },
  computed: {},
  methods: {
    getCouponInfo: function () {
      var urlRequest = "/rest/coupon/" + this.couponId;
      this.loading = false;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.allCouponList = resp.data;
          this.loading = true;
        })
        .catch((err) => {
           
          console.log(err);
          this.loading = false;
        });
    },
    getCouponList: function () {
      var urlRequest = "/rest/coupon/" + this.couponId + "/tickets";
      this.loading = false;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.couponList = resp.data;
          this.tableData = this.couponList;
          this.loading = true;
          console.log("table ist" + JSON.stringify(this.tableData));
          // this.tableData = this.couponList.?map(({ user }) => user);
        })
        .catch((err) => {
           
          console.log(err);
          this.loading = false;
          this.tableData = null;
        });
    },
    openChangeStatusDialog: function (couponId) {
      this.couponDeactivateModal = true;
      // this.sortCouponOptions(couponId);
      this.userCouponID = couponId;
    },

    putCouponStatus: function () {
      var urlRequest =
        "/rest/coupon/ticket/id/" + this.userCouponID + "/status";
      var body = {
        status: "0",
      };
      axios
        .put(urlRequest, body, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp);
          this.couponDeactivateModal = false;
          this.completeModal = true;
          this.couponList = [{}];
          this.userCouponID = "";
          this.getCouponList();
          this.getCouponInfo();
        })
        .catch((err) => {
           console.log(err)
        });
    },
    goBack() {
      this.$router.push({
        name: "クーポン一覧",
        params: { listTab: "copon-discount" },
      });
    },
  },
  beforeMount() {
    this.getCouponList();
    this.getCouponInfo();
  },
};
</script>